import * as React from 'react';

import { translate } from '~l10n/client';

import { FeatureUseEventAdapter } from '~analytics/adapters/FeatureUseEventAdapter';
import { useInviteStudentsDrawerDispatch } from '~teacher/components/ActivityResult/modals/InviteStudentDrawer';

import CloseX from '../../../../shared/components/buttons/CloseX';
import CountdownIcon from '../../../../shared/icons/CountdownIcon';

interface Props {
  countdownText: string;
  countdownTime: string;
  showCountdownFinish: boolean;
  finishClicked: () => void;
  stopCountdownClicked: () => void;
  countdownColor: string;
}

export function SpaceRaceCountdown({
  countdownText,
  countdownTime,
  showCountdownFinish,
  finishClicked,
  stopCountdownClicked,
  countdownColor,
}: Props) {
  const dispatch = useInviteStudentsDrawerDispatch();
  const handleInviteStudents = () => {
    new FeatureUseEventAdapter({
      feature: 'invite_student_drawer',
      action: 'open',
      source: 'space_race_countdown_header',
    }).sendAnalytics();
    dispatch('Open');
  };

  return (
    <div id="countdown-bar" className={'countdown-bar-' + countdownColor}>
      <div className="flex justify-between gap-2">
        <div className="time-remaining truncate">
          <CountdownIcon className="time-remaining-icon" />
          <span className="time-remaining-text">{countdownText}</span>
        </div>
        <div className="flex items-center ">
          <span className="countdown-time">{countdownTime}</span>
        </div>
        <div className="flex items-center gap-3 ">
          {showCountdownFinish ? (
            <button
              className="button button-primary button-small space-race-countdown-finish-button"
              onClick={finishClicked}
            >
              {translate('Finish')}
            </button>
          ) : (
            <>
              <button
                className="button button-primary button-small"
                style={{ border: '1px solid #ffffff', background: 'none' }}
                onClick={handleInviteStudents}
              >
                {translate('Invite Students')}
              </button>
              <div className="stop-countdown" onClick={stopCountdownClicked}>
                <CloseX className="stop-countdown-x" />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
